import i18n from "i18next";
import PropTypes from "prop-types";
import React from "react";
import OverviewSection from "~/assets/js/pages/Checkout/sections/OrderOverview/OverviewSection";

const DeliveryInstructions = ({ shipping }) => {
    const {
        contactless_delivery,
        no_doorbell,
        delivery_phone_call,
        give_porter,
    } = shipping;

    const deliveryInstructions = {
        noDoorbell: no_doorbell,
        deliveryPhoneCall: delivery_phone_call,
        givePorter: give_porter,
        contactlessDelivery: contactless_delivery,
    };

    return (
        <OverviewSection title={"overview.deliveryInstructions.title"}>
            <div className="delivery-instruction_container">
                {Object.keys(deliveryInstructions).map((key) => {
                    if (deliveryInstructions[key]) {
                        return <DeliveryInstructionCard instruction={key} />;
                    }
                })}
            </div>
        </OverviewSection>
    );
};

const DeliveryInstructionCard = ({ instruction }) => {
    return (
        <span className="delivery-instruction">
            <i className="fas fa-check"></i>
            <span>
                {i18n.t(`overview.deliveryInstructions.${instruction}`)}
            </span>
        </span>
    );
};

DeliveryInstructions.propTypes = {
    shipping: PropTypes.object,
};

DeliveryInstructionCard.propTypes = {
    instruction: PropTypes.string.isRequired,
};

export default DeliveryInstructions;
